module.exports = __webpack_public_path__ + "static/media/27OCHA7.4c12bbc0.jpg";